import Decimal from 'decimal.js';

export const MAX_BENCHMARK_MS = 2147483647;

export function benchmarkMinutesToMs(value: string): number {
  if (!value || !/^\d+(?:\.\d+)?$/.test(value.trim())) {
    throw new Error('Enter a nonnegative number of minutes.');
  }
  const ms = new Decimal(value.trim()).times(60000);
  if (!ms.isFinite() || ms.gt(MAX_BENCHMARK_MS)) {
    throw new Error('The duration exceeds the supported maximum (2,147,483,647 milliseconds).');
  }
  return ms.toDecimalPlaces(0, Decimal.ROUND_HALF_UP).toNumber();
}

export function benchmarkMsToMinutes(value: number | string | null | undefined): string {
  return new Decimal(value == null ? 0 : value).div(60000).toDecimalPlaces(8).toFixed();
}
